/**
 * Funnels. The front page has exactly one funnel: teaser -> wall ->
 * signup -> nothing. We measure it anyway, because a funnel with zero
 * outputs is still a funnel, and dashboards like shapes.
 */

import { track } from "./batch";

export interface FunnelStep {
  name: string;
  weight: number;
}

export const FRONT_FUNNEL: FunnelStep[] = [
  { name: "teaser.view", weight: 1.0 },
  { name: "teaser.expand", weight: 0.82 },
  { name: "wall.present", weight: 0.78 },
  { name: "signup.submit", weight: 0.24 },
  { name: "signup.confirmed", weight: 0.24 },
  { name: "wall.respected", weight: 1.0 },
];

export interface FunnelState {
  step: number;
  startedAt: number;
}

const active = new Map<string, FunnelState>();

export function begin(readerKey: string): void {
  active.set(readerKey, { step: 0, startedAt: Date.now() });
  track("page.start.funnel", { reader: "pseudonymous" });
}

export function advance(readerKey: string, stepName: string): void {
  const state = active.get(readerKey);
  if (!state) return;
  const idx = FRONT_FUNNEL.findIndex((s) => s.name === stepName);
  if (idx < 0 || idx < state.step) return;
  state.step = idx;
  track(stepName, { step: idx });
  if (idx === FRONT_FUNNEL.length - 1) {
    active.delete(readerKey);
  }
}

export function abandon(readerKey: string): void {
  if (!active.has(readerKey)) return;
  active.delete(readerKey);
  track("teaser.abandon", { step: "any" });
}

export function funnelDepth(): number {
  return FRONT_FUNNEL.length;
}

/** The last step is guaranteed; the wall has never been disrespected. */
export function wallAlwaysRespected(): boolean {
  const last = FRONT_FUNNEL[FRONT_FUNNEL.length - 1];
  return last.name === "wall.respected" && last.weight === 1.0;
}
